import React, { useEffect } from 'react';
import SiteHeader from '../../shared/SiteHeader';
import SiteFooter from '../../shared/SiteFooter';
import { getAppInsights } from '../../appInsights';

const Products: React.FC = () => {
  useEffect(() => {
    document.title = 'Todonyx LLC - Products';

    const appInsights = getAppInsights();
    appInsights?.trackPageView({ name: 'Products' });
  }, []);

  return (
    <div className="page-wrapper">
      <SiteHeader />
      <div className="page-content container py-5">
        <div className="row justify-content-center">
          <div className="col-12 col-md-10 col-lg-8">
            <h1 className="display-5 fw-bold mb-4">Our Products</h1>
            <p className="lead text-muted mb-5">
              Discover our innovative solutions designed to enhance your spiritual journey and daily
              life.
            </p>

            {/* Walk It With Me Section */}
            <div className="card shadow-sm mb-4">
              <div className="card-body p-4">
                <h2 className="h3 mb-3">
                  <img
                    src="https://www.walkitwithme.com/LogoNoTitle-Small.png"
                    alt="Walk It With Me"
                  />{' '}
                  Walk It With Me
                </h2>
                <p className="mb-3">
                  Walk It With Me is an AI-powered Bible chat application that helps you explore
                  Scripture and apply biblical principles to your everyday life. Whether you have
                  questions about specific passages, need guidance on life situations, or want to
                  deepen your understanding of biblical teachings, Walk It With Me is here to
                  assist.
                </p>
                <div className="mb-3">
                  <h3 className="h5 mb-2">Key Features:</h3>
                  <ul className="list-unstyled ms-3">
                    <li className="mb-2">
                      <i className="bi bi-check-circle-fill text-success me-2"></i>
                      AI-powered conversations about Bible questions and interpretations
                    </li>
                    <li className="mb-2">
                      <i className="bi bi-check-circle-fill text-success me-2"></i>
                      Personalized insights and reflections based on your interactions and questions
                    </li>
                    <li className="mb-2">
                      <i className="bi bi-check-circle-fill text-success me-2"></i>
                      Practical life application guidance rooted in Scripture
                    </li>
                    <li className="mb-2">
                      <i className="bi bi-check-circle-fill text-success me-2"></i>
                      Contextual understanding of biblical passages
                    </li>
                    <li className="mb-2">
                      <i className="bi bi-check-circle-fill text-success me-2"></i>
                      Accessible 24/7 for spiritual guidance and support
                    </li>
                  </ul>
                </div>
                <a
                  href="https://walkitwithme.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary"
                >
                  Visit Walk It With Me
                  <i className="bi bi-box-arrow-up-right ms-2"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SiteFooter />
    </div>
  );
};

export default Products;
